module.exports = __webpack_public_path__ + "pc/img/work_list7.17a1e11c.jpg";